<template>
  <div class="container mb-4">
    <DataTable :value="processOrderList(FINISHED_ORDERS_BY_TYPE('hydro'))" data-key="order.id" :selection.sync="selectedFinishedOrders" :filters="filters">
      <Column selectionMode="multiple" headerStyle="width: 3em"></Column>
      <Column field="startDate" header="Påbörjad" :sortable="true" />
      <Column field="endDate" header="Avslutad" :sortable="true" />
      <Column field="order.id" header="Ordernummer" :sortable="true" />
      <Column header="Kund" :sortable="true">
        <template #body="slotProps">
          {{slotProps.data.order.data.CustomerPlaces[0].Customer.data.name}}
        </template>
      </Column>
      <Column header="Leveransställe" :sortable="true">
        <template #body="slotProps">
          {{slotProps.data.order.data.CustomerPlaces[0].data.name}}
        </template>
      </Column>
      <template #header>
        <div class="p-d-flex">
          <div class="p-inputgroup">
            <Button label="Skapa faktura" icon="pi pi-plus" :disabled="selectedFinishedOrders.length == 0" @click="newInvoice = true" />
            <span class="p-inputgroup-addon" style="color: black">
              <i class="pi pi-search" style="margin: 4px 4px 0px 0px;"></i>
            </span>
            <InputText v-model="filters['global']" placeholder="Sökfilter" size="50" />
          </div>
        </div>
      </template>
      <template #footer>
        <div class="p-d-flex">
          <Button label="Skapa faktura" icon="pi pi-plus" :disabled="selectedFinishedOrders.length === 0" @click="newInvoice = true" />
        </div>
      </template>
      <template #empty>
        Inga ordrar redo för fakturering ännu
      </template>
    </DataTable>

    <Dialog header="Ange namn för ny faktura" :visible.sync="newInvoice">
      <InputText v-model="newInvoiceName" placeholder="Fakturanamn" size="50" />
      <template #footer>
        <Button label="Skapa faktura" icon="pi pi-check" :disabled="newInvoiceName.length === 0" @click="addToNewInvoice(newInvoiceName, selectedFinishedOrders)"/>
        <Button label="Avbryt" icon="pi pi-times" class="p-button-secondary" @click="newInvoice = false" />
      </template>
    </Dialog>

    <template v-for="activeInvoice in INVOICES_NEW_BY_TYPE('hydro').sort((e1, e2) => (-1))" data-key="activeInvoice.id">
      <DataTable :value="processInvoiceList(activeInvoice.invoiceDatas)" data-key="order.id" :key="activeInvoice.id" :selection.sync="selectedOrdersToRemove[activeInvoice.id]">
        <template #header>
          <div class="p-d-flex">
            <div class="p-inputgroup">
              <Button label="Lägg till" icon="pi pi-plus" :disabled="selectedFinishedOrders.length == 0" @click="appendToInvoice(activeInvoice.id, selectedFinishedOrders)" />
              <Button label="Ta bort" icon="pi pi-minus" class="p-button-danger" :disabled="selectedOrdersToRemove[activeInvoice.id] === undefined || selectedOrdersToRemove[activeInvoice.id].length == 0" @click="removeFromInvoice(activeInvoice.id, selectedOrdersToRemove[activeInvoice.id])" />
              <span class="p-inputgroup-addon" style="color: black">
                {{activeInvoice.name}}
              </span>
            </div>
          </div>
        </template>
        <Column selectionMode="multiple" headerStyle="width: 3em" />
        <Column field="startDate" header="Påbörjad" :sortable="true" />
        <Column field="endDate" header="Avslutad" :sortable="true" />
        <Column field="order.Order.id" header="Ordernummer" :sortable="true" />
        <Column header="Kund" :sortable="true">
          <template #body="slotProps">
            {{slotProps.data.order.Order.data.CustomerPlaces[0].Customer.data.name}}
          </template>
        </Column>
        <Column header="Leveransställe" :sortable="true">
          <template #body="slotProps">
            {{slotProps.data.order.Order.data.CustomerPlaces[0].data.name}}
          </template>
        </Column>
        <template #footer>
          <div class="p-d-flex p-jc-between">
            <div>
              <Button label="Fakturera" icon="pi pi-check" class="p-button-success" :disabled="activeInvoice.invoiceDatas.length === 0" @click="$router.push({ name: 'InvoiceHydroCreate', params: { id: activeInvoice.id } })" />
            </div>
            <div>
                <Button label="Ta Bort Faktura" icon="pi pi-minus" class="p-button-danger" :disabled="activeInvoice.invoiceDatas.length > 0" @click="deleteInvoice(activeInvoice.id)" />
                <Button label="Arkivera" icon="pi pi-minus" class="p-button-danger" @click="archiveInvoice(activeInvoice.id)" />
            </div>
          </div>
        </template>
        <template #empty>
          Inga ordrar tillagda på {{activeInvoice.name}}
        </template>
      </DataTable>
    </template>

  </div>
</template>
<script>

import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import SplitButton from 'primevue/splitbutton'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Dialog from 'primevue/dialog'
import moment from 'moment'

import { mapGetters } from 'vuex'

export default {
  name: 'InvoiceHydroList',
  components: {
    DataTable,
    Column,
    SplitButton,
    Button,
    InputText,
    Dialog
  },
  data () {
    return {
      configure: false,
      newInvoice: false,
      newInvoiceName: '',
      createInvoice: -1,
      filters: {},
      selectedOrdersToRemove: {},
      selectedFinishedOrders: [],
      items: [
        {
          label: 'Ladda nya',
          icon: 'pi pi-refresh',
          command: () => {
            this.$store.dispatch('GET_FINISHED_ORDERS')
          }
        }
      ]
    }
  },
  mounted () {
    this.$store.dispatch('GET_FINISHED_ORDERS')
    this.$store.dispatch('GET_ACTIVE_INVOICES')
    this.$store.dispatch('GET_VISMA_ARTICLES')
    this.$store.dispatch('GET_CUSTOMERS')
  },
  computed: {
    ...mapGetters(['FINISHED_ORDERS', 'FINISHED_ORDERS_BY_TYPE', 'INVOICES', 'INVOICES_BY_TYPE', 'INVOICES_NEW_BY_TYPE', 'CUSTOMER_BY_ID'])
  },
  methods: {
    processOrderList (orders) {
      return orders.map((order) => {
        return { startDate: this.getDeliveryDate(order.data.startDate), endDate: this.getDeliveryDate(order.data.endDate), order: order }
      })
    },
    deProcessOrderList (orders) {
      return orders.map((order) => {
        return {...order.order}
      })
    },
    processInvoiceList (orders) {
      return orders.map((order) => {
        return { startDate: this.getDeliveryDate(order.Order.data.startDate), endDate: this.getDeliveryDate(order.Order.data.endDate), order: order }
      })
    },
    async refresh () {
      await this.$store.dispatch('GET_FINISHED_ORDERS')
      await this.$store.dispatch('GET_ACTIVE_INVOICES')
    },
    async refreshAndClear () {
      await this.refresh()
      this.selectedFinishedOrders = []
    },
    async addToNewInvoice (name, orders) {
      await this.$store.dispatch('ADD_ORDERS_TO_NEW_INVOICE', { invoiceType: 'hydro', invoiceName: name, orders: this.deProcessOrderList(orders) })
      await this.refreshAndClear()
      this.newInvoice = false
      this.newInvoiceName = ''
    },
    async appendToInvoice (invoiceId, orders) {
      await this.$store.dispatch('ADD_ORDERS_TO_INVOICE', { invoice: invoiceId, orders: this.deProcessOrderList(orders) })
      await this.refreshAndClear()
    },
    async removeFromInvoice (invoiceId, orders) {
      await this.$store.dispatch('REMOVE_ORDERS_FROM_INVOICE', { invoice: invoiceId, orders: this.deProcessOrderList(orders) })
      await this.refresh()
      this.selectedOrdersToRemove[invoiceId] = []
    },
    archiveInvoice (invoiceId) {
      let message = 'Är du säker?'
      let options = {
        okText: 'Fortsätt',
        cancelText: 'Stäng'
      }
      this.$dialog.confirm(message, options)
        .then(dialog => {
          this.$store.dispatch('ARCHIVE_INVOICE', invoiceId)
          this.refresh()
        })
        .catch(function (e) {
          console.log('Clicked on cancel')
        })
    },
    async deleteInvoice (invoiceId) {
      await this.$store.dispatch('DELETE_INVOICE', invoiceId)
      await this.refresh()
    },
    getDeliveryDate (date) {
      return moment(date).format('YYYY-MM-DD')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Invoices/InvoiceHydroList.vue